module.exports = __webpack_public_path__ + "img/atlas.31650fe4.jpg";